/**
 * Événements PostHog booking — alignés sur shared/product-analytics/event-catalog.yaml
 */

export const ProductAnalyticsFunnels = {
  PRO_ACTIVATION: 'pro_activation',
  BOOKING_LOOP: 'booking_loop',
} as const;

export type ProductAnalyticsFunnel =
  (typeof ProductAnalyticsFunnels)[keyof typeof ProductAnalyticsFunnels];

export const ProductAnalyticsModules = {
  SIGNUP: 'signup',
  RESERVATIONS: 'reservations',
} as const;

export const BookingAnalyticsEvents = {
  PAGE_VIEW: '$pageview',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
  BOOKING_CREATION_STARTED: 'booking_creation_started',
  BOOKING_SERVICE_SELECTED: 'booking_service_selected',
  BOOKING_SLOT_SELECTED: 'booking_slot_selected',
  BOOKING_ADDED_TO_CART: 'booking_added_to_cart',
  BOOKING_CREATION_COMPLETED: 'booking_creation_completed',
  PRO_EMAIL_CONTACT_SENT: 'pro_email_contact_sent',
  BLOG_ARTICLE_VIEW: 'blog_article_view',
  BLOG_ARTICLE_SCROLL: 'blog_article_scroll',
  BLOG_ARTICLE_CTA_CLICKED: 'blog_article_cta_clicked',
  BLOG_ARTICLE_RELATED_CLICKED: 'blog_article_related_clicked',
  BLOG_ARTICLE_SHARE: 'blog_article_share',
  SEARCH_OR_ASK_SUBMITTED: 'search_or_ask_submitted',
  SEARCH_ZERO_RESULTS: 'search_zero_results',
  SEARCH_RESULTS_SHOWN: 'search_results_shown',
  DISCOVERY_PRO_CLICKED: 'discovery_pro_clicked',
  ASK_ANSWER_SHOWN: 'ask_answer_shown',
  ASK_PRO_CLICKED: 'ask_pro_clicked',
  RADIUS_EXPANDED: 'radius_expanded',
  FOLLOW_UP_OPENED: 'follow_up_opened',
  CARNET_VIEWED: 'carnet_viewed',
  CARNET_MARK_DONE: 'carnet_mark_done',
  CARNET_SHARE_CREATED: 'carnet_share_created',
  CARNET_SCAN_IMPORTED: 'carnet_scan_imported',
  CARNET_NIGHT_ASK_SAVED: 'carnet_night_ask_saved',
  CARNET_BLOCK_ASK_SAVED: 'carnet_block_ask_saved',
  CARNET_BRIEF_ASK_SAVED: 'carnet_brief_ask_saved',
} as const;
